import { Component, OnInit, NgZone, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { timer, of, Subscription, Subject, concat } from 'rxjs';
import { switchMap, map, catchError, distinctUntilChanged, tap, debounceTime } from 'rxjs/operators';
import { emailPattern, noWhitespaceInRequiredValidator } from '../../shared/constants';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-sync-vessel',
	templateUrl: './sync-vessel.component.html',
	styleUrl: './sync-vessel.component.css'
})
export class SyncVesselComponent {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/vessel",
			name: "Vessels"
		},
		{
			path: "/app/sync-vessels",
			name: "Sync"
		}
	];
	user_type: any = "";
	accessLoader = false;
	pagetitle = "Sync Vessels to CLIP";
	requiredValidator = Validators.required;
	moduleForm: FormGroup = this.formBuilder.group({
		id: [[], [this.requiredValidator, noWhitespaceInRequiredValidator]],
		company: [[], [this.requiredValidator, noWhitespaceInRequiredValidator]],
	});
	customError: any = {};
	formSubmitted = false;
	showLoader = false;

	vessels: any[] = [];
	vesselSearchInput$ = new Subject<string>();
	loadingVessels = false;
	start = 0;
	limit = 20;
	hasMore = true;
	currentSearchTerm = '';

	companies: any[] = [];
	loadingCompanies = false;
	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, private zone: NgZone) {
		this.accessLoader = true;
		this.apiService.getUserAccess().subscribe({
			next: (data: any) => {
				this.accessLoader = false;
				try {
					this.user_type = data.res[0].user_type;
				} catch (error) { }
			}, error: (error: any) => {
				this.accessLoader = false;
			}
		});
		this.getVessels();
		this.getMainCompanies();
		this.vesselSearchInput$.pipe(debounceTime(500), distinctUntilChanged(), tap(() => {
			this.loadingVessels = true;
			this.start = 0;
			this.hasMore = true;
		}), switchMap(term => {
			this.currentSearchTerm = term;
			return this.apiService.getVesselDetails(this.getVesselPayload()).pipe(
				catchError(() => of([]))
			);
		})).subscribe((res: any) => {
			this.vessels = res.data;
			this.loadingVessels = false;
			if (res.data.length < this.limit) {
				this.hasMore = false;
			}
		});
	}

	getVesselPayload() {
		return {
			draw: 1,
			start: this.start,
			length: this.limit,
			searchVal: this.currentSearchTerm || ""
		};
	}

	getVessels() {
		this.loadingVessels = true;
		this.apiService.getVesselDetails(this.getVesselPayload()).subscribe({
			next: (res: any) => {
				this.vessels = res.data;
				this.loadingVessels = false;
				if (res.data.length < this.limit) {
					this.hasMore = false;
				}
			}, error: (error) => {
				this.loadingVessels = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch vessels.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	loadMoreVessels() {
		if (this.loadingVessels || !this.hasMore) {
			return;
		}
		this.loadingVessels = true;
		this.start += this.limit;
		this.apiService.getVesselDetails(this.getVesselPayload()).subscribe({
			next: (res: any) => {
				this.vessels = [...this.vessels, ...res.data];
				this.loadingVessels = false;
				if (res.data.length < this.limit) {
					this.hasMore = false;
				}
			}, error: (error) => {
				this.loadingVessels = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch vessels.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getMainCompanies() {
		this.loadingCompanies = true;
		this.apiService.getMainCompaniesCLIP({}).subscribe({
			next: (res: any) => {
				this.companies = res;
				this.loadingCompanies = false;
			}, error: (error) => {
				this.loadingCompanies = false;
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch companies.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	get f() { return this.moduleForm.controls; }

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {

				}

			}
		});
		this.customError = {};
	}

	saveData() {
		console.log(this.moduleForm.value)
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let payload: any = this.moduleForm.value;
		this.showLoader = true;
		this.apiService.syncVesselToCLIPCompany(payload).subscribe({
			next: data => {
				this.showLoader = false;
				this.toastr.success("Saved successfully.", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.gotoList();
			}, error: (error: any) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg: any = "Something went wrong.";
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val == "This field must be unique.") {
								val = "Already exists";
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val;
								let selector = "#" + key;
								try {
									$('html, body').animate({
										scrollTop: $(selector).offset().top - 60 + 'px'
									}, 'fast');
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ":" + val, 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						}
						return;
					}
				} else {
					errorMsg = error.error;
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	gotoList() {
		this.router.navigate(['/app/vessel']);
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}
}
